document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav */
  var navToggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var navClose = document.querySelector('.mobile-nav__close');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () { mobileNav.classList.add('is-open'); });
  }
  if (navClose && mobileNav) {
    navClose.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
  }

  /* ============ Hero slider (editor-aware) ============ */
  function initHeroSlider(slider) {
    if (slider._heroApi) return slider._heroApi; // already initialized
    var slides = slider.querySelectorAll('.hero-slide');
    var dots = slider.querySelectorAll('.hero-slider__dot');
    var prev = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    if (slides.length < 2) return null;
    var i = 0, timer;

    function show(idx) {
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === idx); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
      i = idx;
    }
    function go(dir) { show((i + dir + slides.length) % slides.length); }
    function loop() {
      clearInterval(timer);
      timer = setInterval(function () { go(1); }, 6000);
    }
    function pause() { clearInterval(timer); }

    dots.forEach(function (d, di) { d.addEventListener('click', function () { show(di); loop(); }); });
    if (next) next.addEventListener('click', function () { go(1); loop(); });
    if (prev) prev.addEventListener('click', function () { go(-1); loop(); });
    show(0);
    loop();

    var api = { show: show, pause: pause, resume: loop, slides: slides };
    slider._heroApi = api;
    return api;
  }
  document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);

  /* ============ Brands showcase switcher (editor-aware) ============ */
  function initBrandSwitcher(wrap) {
    if (wrap._brandApi) return wrap._brandApi; // already initialized
    var panels = wrap.querySelectorAll('[data-brand-panel]');
    var thumbs = wrap.querySelectorAll('[data-brand-thumb]');
    var tracks = wrap.querySelectorAll('[data-brand-progress]');
    var prev = wrap.querySelector('[data-brand-prev]');
    var next = wrap.querySelector('[data-brand-next]');
    if (!panels.length) return null;

    var durationMs = (parseFloat(getComputedStyle(wrap).getPropertyValue('--brand-duration')) || 6) * 1000;
    var i = 0, timer;

    function render(idx) {
      idx = Math.max(0, Math.min(idx, panels.length - 1));
      panels.forEach(function (p, pi) { p.classList.toggle('is-active', pi === idx); });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === idx); });
      tracks.forEach(function (t, ti) {
        t.classList.remove('is-active', 'is-done');
        if (ti < idx) t.classList.add('is-done');
      });
      // force reflow so the CSS animation restarts on the active track
      if (tracks[idx]) {
        void tracks[idx].offsetWidth;
        tracks[idx].classList.add('is-active');
      }
      i = idx;
    }

    function go(dir) { render((i + dir + panels.length) % panels.length); }

    function play() {
      clearInterval(timer);
      if (panels.length < 2) return;
      timer = setInterval(function () { go(1); }, durationMs);
    }
    function pause() { clearInterval(timer); }

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { render(idx); play(); });
    });
    if (next) next.addEventListener('click', function () { go(1); play(); });
    if (prev) prev.addEventListener('click', function () { go(-1); play(); });

    wrap.addEventListener('mouseenter', pause);
    wrap.addEventListener('mouseleave', play);

    render(0);
    play();

    var api = { render: render, pause: pause, resume: play, panels: panels };
    wrap._brandApi = api;
    return api;
  }
  document.querySelectorAll('[data-brand-switcher]').forEach(initBrandSwitcher);

  /* ============ Shopify Theme Editor integration ============ */
  if (window.Shopify && window.Shopify.designMode) {
    // Re-init any freshly (re)rendered section so sliders keep working while editing.
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
      e.target.querySelectorAll('[data-brand-switcher]').forEach(initBrandSwitcher);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-hero-slider]').forEach(function (el) {
        if (el._heroApi) el._heroApi.pause();
      });
      e.target.querySelectorAll('[data-brand-switcher]').forEach(function (el) {
        if (el._brandApi) el._brandApi.pause();
      });
    });

    // When a merchant clicks a slide/brand block in the sidebar, jump straight
    // to that panel and pause autoplay so the preview always matches selection.
    document.addEventListener('shopify:block:select', function (e) {
      var heroSlide = e.target.closest('.hero-slide');
      if (heroSlide) {
        var heroSlider = heroSlide.closest('[data-hero-slider]');
        var heroApi = heroSlider && initHeroSlider(heroSlider);
        if (heroApi) {
          var idx = Array.prototype.indexOf.call(heroApi.slides, heroSlide);
          heroApi.pause();
          heroApi.show(idx);
        }
        return;
      }
      var brandPanel = e.target.closest('[data-brand-panel]');
      if (brandPanel) {
        var brandWrap = brandPanel.closest('[data-brand-switcher]');
        var brandApi = brandWrap && initBrandSwitcher(brandWrap);
        if (brandApi) {
          var pIdx = Array.prototype.indexOf.call(brandApi.panels, brandPanel);
          brandApi.pause();
          brandApi.render(pIdx);
        }
      }
    });

    // Resume autoplay once the merchant clicks away from the block.
    document.addEventListener('shopify:block:deselect', function (e) {
      var heroSlider = e.target.closest && e.target.closest('[data-hero-slider]');
      if (heroSlider && heroSlider._heroApi) heroSlider._heroApi.resume();
      var brandWrap = e.target.closest && e.target.closest('[data-brand-switcher]');
      if (brandWrap && brandWrap._brandApi) brandWrap._brandApi.resume();
    });
  }

  /* Stat dials — animate on scroll into view */
  var dials = document.querySelectorAll('.stat-dial');
  if (dials.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var dial = entry.target;
        var target = parseFloat(dial.getAttribute('data-value')) || 0;
        var valueEl = dial.querySelector('.stat-dial__value');
        var fill = dial.querySelector('.stat-dial__fill');
        var max = parseFloat(dial.getAttribute('data-max')) || target;
        var circumference = 301;
        var offset = circumference - Math.min(target / max, 1) * circumference;
        if (fill) fill.style.strokeDashoffset = offset;
        var start = 0, duration = 1200, startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var current = Math.floor(progress * target);
          if (valueEl) valueEl.textContent = current;
          if (progress < 1) requestAnimationFrame(step);
          else if (valueEl) valueEl.textContent = target;
        }
        requestAnimationFrame(step);
        obs.unobserve(dial);
      });
    }, { threshold: 0.4 });
    dials.forEach(function (d) { obs.observe(d); });
  }

  /* Newsletter form (Shopify customer form handles submit natively) */

  /* Quantity steppers on product/cart */
  document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
  });
  document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  /* ============ Money formatting ============ */
  function formatMoney(cents) {
    var format = (window.themeMoneyFormat || '${{amount}}');
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ============ Cart Drawer ============ */
  var CartDrawer = (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return null;
    var body = drawer.querySelector('[data-cart-drawer-body]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var routes = window.themeRoutes || {};

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function lineHTML(item) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_160x160$1') : '';
      return (
        '<div class="cart-drawer__line" data-line-key="' + item.key + '">' +
          (img ? '<a href="' + item.url + '" class="cart-drawer__line-img"><img src="' + img + '" alt="' + (item.product_title || '') + '"></a>' : '') +
          '<div class="cart-drawer__line-info">' +
            '<a href="' + item.url + '" class="cart-drawer__line-title">' + item.product_title + '</a>' +
            (item.variant_title ? '<div class="cart-drawer__line-variant">' + item.variant_title + '</div>' : '') +
            '<div class="cart-drawer__line-price">' + formatMoney(item.final_price) + '</div>' +
            '<div class="cart-drawer__qty">' +
              '<button type="button" data-qty-minus>&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-plus>&plus;</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-drawer__remove" type="button" data-remove aria-label="Remove">&times;</button>' +
        '</div>'
      );
    }

    function render(cart) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>' +
          (drawer.getAttribute('data-empty-text') || 'Your cart is empty.') +
          '</p><a href="' + (routes.cartUrl || '/cart') + '" class="btn btn--solid" data-cart-close>Continue shopping</a></div>';
      } else {
        body.innerHTML = cart.items.map(lineHTML).join('');
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
    }

    function refresh() {
      return fetch((routes.cartUrl || '/cart') + '.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    function changeLine(key, quantity) {
      return fetch(routes.cartChange || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    body.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qtySpan = line.querySelector('.cart-drawer__qty span');
      var qty = parseInt(qtySpan.textContent, 10);

      if (e.target.closest('[data-qty-plus]')) { changeLine(key, qty + 1); }
      if (e.target.closest('[data-qty-minus]')) { changeLine(key, Math.max(0, qty - 1)); }
      if (e.target.closest('[data-remove]')) { changeLine(key, 0); }
    });

    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    refresh();

    return { open: open, close: close, refresh: refresh };
  })();

  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!CartDrawer) return;
      e.preventDefault();
      CartDrawer.open();
    });
  });

  /* Intercept product add-to-cart forms for AJAX add */
  document.querySelectorAll('form[data-product-form], form.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var routes = window.themeRoutes || {};
      var btn = form.querySelector('[data-add-to-cart]');
      var spinner = form.querySelector('[data-add-to-cart-spinner]');
      if (btn) btn.setAttribute('disabled', 'disabled');
      if (spinner) spinner.hidden = false;

      var formData = new FormData(form);
      fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            alert((window.themeStrings && window.themeStrings.cartError) || data.description || 'Error adding to cart');
            return;
          }
          if (CartDrawer) {
            CartDrawer.refresh().then(function () { CartDrawer.open(); });
          }
        })
        .catch(function () {
          alert((window.themeStrings && window.themeStrings.cartError) || 'Error adding to cart');
        })
        .finally(function () {
          if (btn) btn.removeAttribute('disabled');
          if (spinner) spinner.hidden = true;
        });
    });
  });

  /* ============ Predictive Search ============ */
  (function () {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    var input = modal.querySelector('[data-predictive-search-input]');
    var results = modal.querySelector('[data-predictive-search-results]');
    var routes = window.themeRoutes || {};
    var debounceTimer;

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 150);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    modal.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function renderResults(data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        results.innerHTML = '<p class="search-modal__empty">' + ((window.themeStrings && window.themeStrings.searchNoResults) || 'No results found') + '</p>';
        return;
      }
      results.innerHTML = products.map(function (p) {
        var img = p.featured_image ? p.featured_image.url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_120x120$1') : '';
        return (
          '<a class="search-result" href="' + p.url + '">' +
            (img ? '<span class="search-result__img"><img src="' + img + '" alt="' + p.title + '"></span>' : '') +
            '<span><span class="search-result__title">' + p.title + '</span><br><span class="search-result__price">' + p.price + '</span></span>' +
          '</a>'
        );
      }).join('');
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }
      debounceTimer = setTimeout(function () {
        var url = (routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,vendor,product_type';
        fetch(url)
          .then(function (res) { return res.json(); })
          .then(renderResults)
          .catch(function () {});
      }, 280);
    });
  })();

  /* ============ Collection filters ============ */
  (function () {
    var filters = document.querySelector('[data-filters]');
    if (!filters) return;
    var overlay = document.querySelector('.collection-filters__overlay');
    var openBtn = document.querySelector('[data-filters-open]');
    var closeBtns = document.querySelectorAll('[data-filters-close]');
    var sortSelect = document.querySelector('[data-sort-select]');
    var sortHidden = document.querySelector('[data-sort-hidden]');
    var form = document.querySelector('[data-filters-form]');

    if (openBtn) openBtn.addEventListener('click', function () {
      filters.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    });
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filters.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
      });
    });

    if (sortSelect && sortHidden && form) {
      sortSelect.addEventListener('change', function () {
        sortHidden.value = sortSelect.value;
        form.submit();
      });
    }
  })();

  /* ============ Quick add-to-cart (product cards) ============ */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var routes = window.themeRoutes || {};
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      btn.setAttribute('data-loading', 'true');

      fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            alert((window.themeStrings && window.themeStrings.cartError) || data.description || 'Error adding to cart');
            return;
          }
          if (typeof CartDrawer !== 'undefined' && CartDrawer) {
            CartDrawer.refresh().then(function () { CartDrawer.open(); });
          }
        })
        .catch(function () {
          alert((window.themeStrings && window.themeStrings.cartError) || 'Error adding to cart');
        })
        .finally(function () {
          btn.removeAttribute('data-loading');
        });
    });
  });

  /* ============ Featured collection slider ============ */
  document.querySelectorAll('[data-product-slider]').forEach(function (slider) {
    var track = slider.querySelector('.featured-collection__track');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (!track) return;
    function scrollAmount() {
      var slide = track.querySelector('.featured-collection__slide');
      return slide ? slide.getBoundingClientRect().width + 20 : 280;
    }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
  });
});
